import { Dialog, DialogTitle, IconButton, Slide, styled } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { GridCloseIcon } from "@mui/x-data-grid";
import { ReactElement, createElement, forwardRef } from "react";
import { IconType } from "react-icons/lib";
import { TbNote } from "react-icons/tb";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

type ModalOptions = {
    title?: string;
    size?: "sm" | "md" | "lg" | "xl";
    onClose?: (closeData?: unknown) => void;
    closeData?: unknown;
    open: boolean;
    icon?: IconType | false;
};

const CommonPopup = ({
    children,
    open,
    onClose,
    size,
    title,
    icon = TbNote,
}: { children: ReactElement } & ModalOptions) => {
    return (
        <BootstrapDialog
            TransitionComponent={Transition}
            open={open}
            maxWidth={size || "md"}
            className="!min-h-[80vh] !max-h-[98vh] !overflow-hidden"
            classes={{
                paper: "!bg-gray-50",
            }}
            fullWidth
            onClose={onClose}
            aria-describedby="alert-dialog-slide-description"
            disableAutoFocus
        >
            <DialogTitle
                sx={{ m: 0, p: 2 }}
                id="customized-dialog-title"
                className="font-semibold flex items-center gap-2"
            >
                {icon && createElement(icon)}
                {title}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <GridCloseIcon />
            </IconButton>
            {children}
        </BootstrapDialog>
    );
};

export default CommonPopup;
